import { z } from "zod/v4";

export const literalSchema = z.object({
	type: z.literal("literal"),
	value: z.union([z.number(), z.string(), z.boolean(), z.null()]),
});
export type Literal = z.infer<typeof literalSchema>;

export const literal = (value: number | string | boolean | null): Literal => ({
	type: "literal",
	value,
});

// Expression types

export const subqueryRefSchema = z.object({
	type: z.literal("subquery"),
	subqueryId: z.string(),
});
export type SubqueryRef = z.infer<typeof subqueryRefSchema>;

export const subqueryRef = (subqueryId: string): SubqueryRef => ({
	type: "subquery",
	subqueryId,
});

export const jsonpathRefSchema = z.object({
	type: z.literal("jsonpath-table-ref"),
	table: z.string(),
	path: z
		.string()
		.transform((val): `$${string}` => (val.startsWith("$") ? val : `$${val}`) as `$${string}`)
		.refine((val) => val.startsWith("$"), {
			message: "Path must start with $",
		}),
});
export type JsonPathRef = z.infer<typeof jsonpathRefSchema>;

export const jsonpathRef = (table: string, path: `$${string}`): JsonPathRef => ({
	type: "jsonpath-table-ref",
	table,
	path,
});

export const isJsonPathRef = (value: unknown): value is JsonPathRef =>
	typeof value === "object" &&
	value !== null &&
	"type" in value &&
	value.type === "jsonpath-table-ref";

// Comparison operators
export const linearComparisonOperatorSchema = z.enum([
	"=",
	"!=",
	"<>",
	">",
	"<",
	">=",
	"<=",
	"LIKE",
	"GLOB",
	"IS",
	"IS NOT",
]);
export type LinearComparisonOperator = z.infer<typeof linearComparisonOperatorSchema>;

// FIXME: lots of those linear operators should be bilinear operators too, depending whether there
// is a subquery.
export const bilinearComparisonOperatorSchema = z.enum(["IN", "NOT IN" /*"EXISTS", "NOT EXISTS"*/]);
export type BilinearComparisonOperator = z.infer<typeof bilinearComparisonOperatorSchema>;
